import jsPDF from 'jspdf'
import 'jspdf-autotable'
import preLoader from '@/config/mixins/preLoader';

export default {
    data() {
        return {
            fullPage: false
        }
    },
    mixins: [preLoader],
    methods: {
        
        relPDF(bodyRows, headRows, columns, title, type, name, tLoader = null, mBottom = null, forma = null) {
           
            var doc = jsPDF(forma || 'p')
            let temLoader = tLoader || 3000;
            var totalPagesExp = '{total_pages_count_string}'
            let colWidth = {}   
            let loader = this.openLoader();
            
            colTable(columns, colWidth);
            
            setTimeout(() => {
                titleBold(doc, title);
                doc.setFontStyle('normal');
                tableFooter(doc, headRows, bodyRows, colWidth, mBottom, totalPagesExp);
                
                // Total page number plugin only available in jsPDF v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                
                if (type == 'salvar') {   
                    doc.save(name);
                } else if (type == 'imprimir'){
                    doc.autoPrint();
                    window.open(URL.createObjectURL(doc.output("blob")),"_blank" )
                }
                
                loader.hide()
            }, temLoader)
        },
        
        
        docTXT(dados, campos, nome, delimitador = null) {
            let sep = delimitador || "|";
            let name = nome || "arquivo";
            let data = dados;
            let fileTxt = "";
            let field = campos;
          
            let loader = this.openLoader();
            data.forEach(e => {
                let val = ""
                for (let i = 0; i < field.length; i++) {
                    if (i == field.length - 1) {
                        val = val + e[field[i]];
                    } else {
                        val = val + e[field[i]] + sep;
                    }
                }
                fileTxt = fileTxt + val + "\n";
            });
            
            this.$exportTxt(fileTxt.toUpperCase(), name);
            
            setTimeout(() => {
                loader.hide();
            }, 2000);
            
        },
        
        verAuditoria(bodyRows, headRows, descricao) {
            var doc = new jsPDF()
            var totalPagesExp = '{total_pages_count_string}'
            let colWidth = {}
            
            titleBold(doc, 'Detalhes da Auditoria.');
            
            doc.autoTable({
                head: '',
                body: descricao,
                columnStyles: { 0:{cellWidth:40}, 1:{cellWidth:141}},
                startY: 20,
                theme: 'grid',
            })
            
            colTable([39, 71, 71], colWidth);
            
            tableFooter(doc, headRows, bodyRows, colWidth, doc.autoTable.previous.finalY + 0, totalPagesExp);
            
            // Total page number plugin only available in jsPDF v1.0+
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            
            doc.autoPrint();
            window.open(URL.createObjectURL(doc.output("blob")),"_blank" )
        },
        
        totalTable(rowTotal){
            let row = []
            rowTotal.forEach(element => {
                row.unshift({
                    colSpan: element.colSpan,
                    content: element.descricao,
                    styles: {
                        halign: 'right',
                        fillColor: [223, 223, 223],
                        fontStyle: 'bold'
                    }
                })
            });
            return row
        },
        
        moeda(value) {
            let val = (value/1).toFixed(2).replace('.', ',');
            return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        
        numMilhar(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },      
    },
}

function tableFooter(doc, dadosHead, dadosBody, colWidth, mBottom, totalPagesExp) {
    let mgBottom = mBottom || 17;
    doc.autoTable({
        theme: 'grid',
        headStyles: {
            fillColor: [223, 223, 223],
            fontStyle: 'bold',
            fontSize: 9,
            textColor: [59, 59, 59]
        },
        bodyStyles: {
            fontSize: 9
        },
        head: [dadosHead],
        body: dadosBody,
        columnStyles: colWidth,
        startY: mgBottom,
        didDrawPage: function (data) {
            // Footer
            var str = 'Página ' + doc.internal.getNumberOfPages();
            // Total page number plugin only available in jsPDF v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' de ' + totalPagesExp + '  -  ' + new Date().toLocaleString() + '.';
            }
            doc.setFontStyle('normal');
            doc.setFontSize(9);
            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, data.settings.margin.left + 125, pageHeight - 2);
        },
    });
}

function titleBold(doc, titulo) {
    doc.setFontSize(12);
    doc.setFontStyle('bold');
    doc.text(titulo, 14, 16);
}

function titleNormal(doc, titulo) {
    doc.setFontSize(10);
    doc.setFontStyle('normal');
    doc.text(titulo, 14, 16);
}

function colTable(columns, colWidth) {
    for (let i = 0; i < columns.length; i++) {
        colWidth[i] = {
            cellWidth: columns[i]
        };
    }
}





